import { render, staticRenderFns } from "./DiscountedItems.vue?vue&type=template&id=2afcc899&"
import script from "./DiscountedItems.vue?vue&type=script&lang=js&"
export * from "./DiscountedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports